const orderDetails = {
  'orderDetails.title': 'Детали заказа',
  'orderDetails.tab.goodsList': 'Список товаров',
  'orderDetails.tab.payments': 'Платёжная информация',
  'orderDetails.tab.shipments': 'Информация об отгрузке',
  'orderDetails.tab.logistics': 'Логистика',
  'orderDetails.tab.operationLog': 'История операций',

  'orderDetails.fetch.orderId.empty': 'ID заказа не может быть пустым',

  'orderDetails.content.orderInfo.title': 'Информация о заказе',
  'orderDetails.export.productList': 'Экспорт списка товаров',
  'orderDetails.export.exporting': 'Экспорт списка товаров...',
  'orderDetails.export.success.message': 'Экспорт успешен',
  'orderDetails.export.success.description': 'Список товаров успешно экспортирован, проверьте папку загрузок',
  'orderDetails.export.failed': 'Экспорт не удался, попробуйте позже',

  'orderDetails.content.customerInfo.title': 'Информация о покупателе',
  'orderDetails.content.customerInfo.shopId': 'ID магазина',
  'orderDetails.content.customerInfo.shopName': 'Название магазина',

  'orderDetails.content.shippingInfo.title': 'Данные получателя',
  'orderDetails.content.shippingInfo.recipientName': 'Получатель',
  'orderDetails.content.shippingInfo.phone': 'Телефон/Стационарный',
  'orderDetails.content.shippingInfo.postalCode': 'Почтовый индекс',
  'orderDetails.content.shippingInfo.email': 'Эл. почта',
  'orderDetails.content.shippingInfo.address': 'Адрес доставки',

  'orderDetails.content.amountInfo.title': 'Финансовые данные',
  'orderDetails.content.amountInfo.goodsAmount': 'Сумма товаров',
  'orderDetails.content.amountInfo.otherAmount': 'Прочие расходы',

  'orderDetails.feeType': 'Тип расхода',
  'orderDetails.feeAmount': 'Сумма',

  'orderDetails.productList.partsNum': 'Номер детали',
  'orderDetails.productList.productTitle': 'Характеристики товара',
  'orderDetails.productList.replacePartsNum': 'Заменяемый номер',
  'orderDetails.productList.unitPrice': 'Цена за единицу',
  'orderDetails.productList.totalPrice': 'Итоговая цена',
  'orderDetails.productList.totalQuantity': 'Общее количество',
  'orderDetails.productList.shippedQuantity': 'Отгружено',

  'orderDetails.operationRecord.operationType': 'Тип операции',
  'orderDetails.operationRecord.operationUser': 'Оператор',
  'orderDetails.operationRecord.operationDate': 'Дата операции',

  'orderDetails.payments.paymentId': 'ID платежа',
  'orderDetails.payments.paymentMethod': 'Способ оплаты',
  'orderDetails.payments.paymentAmount': 'Сумма платежа',
  'orderDetails.payments.paymentDate': 'Дата платежа',
  'orderDetails.payments.payer': 'Плательщик',
  'orderDetails.payments.payerContact': 'Контактные данные',
  'orderDetails.payments.description': 'Описание',

  'orderDetails.shipments.shipmentId': 'ID отгрузки',
  'orderDetails.shipments.shippingMethod': 'Способ доставки',
  'orderDetails.shipments.shippingStatus': 'Статус отгрузки',
  'orderDetails.shipments.shippingDate': 'Дата отгрузки',
};

export default orderDetails;
